export const services = [
  {
    id: 'reportages',
    icon: 'Camera',
    title: 'Reportages photographiques',
    shortDesc: "Une banque d'images personnalisée, représentative des milieux naturels dont vous avez la gestion.",
    fullDesc: "Parce que chaque territoire est unique, disposez de photos originales de la biodiversité et des milieux aquatiques qui sont les vôtres. Une mine d'or pour vos outils de communication, projets d'exposition, sensibilisation… à exploiter sans modération !",
    subtitle: "Constituez-vous une banque d'images personnalisée, représentative des milieux naturels dont vous avez la gestion.",
    details: [
      { icon: 'Calendar', text: 'Période idéale pour la prise de vue : de mai à septembre' },
      { icon: 'Clock', text: 'Durée du reportage : de 1 à 4 jours' },
      { icon: 'Sunrise', text: 'Livraison d\'environ 25 photos en haute définition / jour' },
      { icon: 'Palette', text: 'Retouches comprises' },
      { icon: 'CheckCircle', text: 'Droits cédés pour 10 ans' },
      { icon: 'FileText', text: 'Textes descriptifs des photos fournis' },
      { icon: 'Search', text: 'Étude gratuite de votre projet' },
    ],
    cta: 'Contactez-moi pour programmer votre reportage photo !',
    image: 'https://customer-assets.emergentagent.com/job_template-astud/artifacts/ay7sfonr__DSC7050.jpg',
  },
  {
    id: 'audiovisuel',
    icon: 'Video',
    title: 'Réalisations audiovisuelles',
    shortDesc: "Montrez les merveilles inaccessibles et pourtant si proches qu'offrent les cours d'eau !",
    fullDesc: "À travers un film de quelques minutes, je vous propose de présenter votre bassin versant avec des images subaquatiques et aériennes permettant d'offrir une nouvelle vision de votre territoire. Ces films valorisent la communication des gestionnaires et donnent l'occasion au public de redécouvrir leur rivière.",
    subtitle: "Montrez les merveilles inaccessibles et pourtant si proches qu'offrent les cours d'eau !",
    details: [],
    cta: 'Découvrez Aquatique Productions, ma structure dédiée à l\'audiovisuel',
    image: 'https://customer-assets.emergentagent.com/job_template-astud/artifacts/1pe8mtn5_Visuelle.jpeg',
  },
  {
    id: 'conference',
    icon: 'Mic',
    title: 'Conférence tout public',
    shortDesc: "Une conférence rafraîchissante, ludique et interactive pour tous publics !",
    fullDesc: "Tout savoir sur les secrets des prises de vues subaquatiques et partir avec le photographe à la rencontre de notre biodiversité, des sources aux estuaires.",
    subtitle: "Une conférence rafraîchissante, ludique et interactive pour tous publics !",
    details: [],
    cta: 'Contactez-moi pour programmer une conférence',
    image: 'https://customer-assets.emergentagent.com/job_template-astud/artifacts/f8yido9o_conference.jpeg',
  },
  {
    id: 'expositions',
    icon: 'Image',
    title: "Location d'expositions",
    shortDesc: "Chaque milieu aquatique est un petit monde avec ses spécificités et ses habitants.",
    fullDesc: "",
    subtitle: "Deux expositions disponibles à la location",
    exhibitions: [
      {
        title: 'Six pieds sous l\'eau, la vie',
        desc: "Chaque milieu aquatique est un petit monde avec ses spécificités et ses habitants. La flore et la faune de la rivière révèlent leur beauté en dansant dans le courant ou en offrant des perspectives et ambiances originales. Surprenants animaux et paysages immergés, tour à tour empreints de calme, de puissance ou de subtilité.",
        specs: '38 panneaux photos 60/90 cm — 38 panneaux textes 20/60 cm'
      },
      {
        title: 'Des poissons et des hommes',
        desc: "Admirez vingt espèces emblématiques de poissons d'eau douce dans leurs milieux naturels. Chaque image est complétée par un texte permettant de sensibiliser le public sur la biologie de l'espèce, ses caractéristiques et les perturbations d'origine humaine qui l'impactent.",
        specs: '20 panneaux photos 50/75 cm — 20 panneaux textes 20/75 cm'
      }
    ],
    details: [],
    cta: 'Contactez-moi pour réserver une exposition',
    image: 'https://customer-assets.emergentagent.com/job_template-astud/artifacts/tmi2z2fx_location.jpeg',
  },
  {
    id: 'droits',
    icon: 'Globe',
    title: "Cession de droits d'images",
    shortDesc: "Une photothèque sur la biodiversité des eaux douces — 7 catégories, près de 500 photos.",
    fullDesc: "7 catégories et près de 500 photos originales en haute définition disponibles pour vos projets.",
    subtitle: "Une photothèque sur la biodiversité des eaux douces à votre disposition",
    categories: [
      'Végétaux aquatiques',
      'Macro-invertébrés dans le milieu naturel',
      'Amphibiens',
      "Poissons d'eau douce",
      "Espèces d'eau douce de l'Île de la Réunion",
      'Poissons côtiers',
      "L'homme et la rivière"
    ],
    details: [],
    cta: 'Consulter la photothèque / Me contacter pour une demande',
    image: 'https://customer-assets.emergentagent.com/job_template-astud/artifacts/tj7wpavl__DSC5132-8.jpg',
  }
];
